<div class="container my-5">
  <h2 class="benefits-title text-center mb-3">
    {{ "Lleva tu panel al nivel Pro" | translate }}
  </h2>
  <p class="benefits-text text-center mb-5">
    {{
      "Gracias a tu volumen de compra, se puede habilitar automáticamente una nueva
      sección en tu panel de control donde tendrás acceso a los beneficios
      exclusivos." | translate
    }}
  </p>

  
  <div class="image-wrapper m-auto">
    <img
      src="{{ '/images/control-panel.png' | blobstorage }}"
      data-src="{{ '/images/control-panel.png' | blobstorage }}"
      alt="control-panel.png"
      class="border rounded-3 shadow"
    />
  </div>

  <div class="text-center mt-5">
    <p class="benefits-text mb-4">
      {{
        "Si tienes dudas sobre el nivel de compras necesario para ser parte de Akky 
        Pro, contacta a nuestro equipo de soporte y 
        conoce más sobre cómo ser parte del programa." | translate
      }}
    </p>
    <button
      class="btn btn-bennefits fw-bold"
      (click)="openWhatsApp()"
    >
      {{ "Quiero ser Akky Pro" | translate }}
    </button>
  </div>
</div>
